import { render, staticRenderFns } from "./ItemDescontoAcrescimoModal.vue?vue&type=template&id=7842cd93&scoped=true"
import script from "./ItemDescontoAcrescimoModal.vue?vue&type=script&lang=js"
export * from "./ItemDescontoAcrescimoModal.vue?vue&type=script&lang=js"
import style0 from "./ItemDescontoAcrescimoModal.vue?vue&type=style&index=0&id=7842cd93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7842cd93",
  null
  
)

export default component.exports